import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { HasPlaidAssetReport, IsExpressLoan, RulesetResult } from '../rules';

export class BankStatements2MonthRuleset implements Ruleset {
  public evaluate(data: Partial<ApplicationFormValues>): RulesetResult {
    const isExpress = IsExpressLoan.evaluate(data);
    const hasPlaidAssetReport = HasPlaidAssetReport.evaluate(data);

    if (isExpress || hasPlaidAssetReport) return RulesetResult.OPTIONAL;

    return RulesetResult.REQUIRED;
  }
}

export default new BankStatements2MonthRuleset();
